import {
  BigTextArea,
  BigTextInput,
  FieldShell,
  YesNoToggle,
} from './FieldPrimitives';

const LifestyleSection = ({ responses, setField }) => {
  return (
    <div className="space-y-6">
      <p className="text-base md:text-lg text-gray-700">
        These questions help your doctor understand your overall health.
      </p>

      <FieldShell label="Do you exercise regularly?">
        <YesNoToggle
          value={responses.exercises_regularly}
          onChange={(v) => setField('exercises_regularly', v)}
        />
      </FieldShell>

      <FieldShell label="Do you smoke tobacco?">
        <YesNoToggle
          value={responses.tobacco}
          onChange={(v) => setField('tobacco', v)}
        />
      </FieldShell>

      <FieldShell label="Do you drink alcohol?">
        <YesNoToggle
          value={responses.drinks_alcohol}
          onChange={(v) => setField('drinks_alcohol', v)}
        />
      </FieldShell>

      {responses.drinks_alcohol === true && (
        <FieldShell
          label="How often do you drink alcohol?"
          htmlFor="alcohol"
          help="Example: Socially, 1-2 drinks per week."
        >
          <BigTextInput
            id="alcohol"
            value={responses.alcohol}
            onChange={(v) => setField('alcohol', v)}
            maxLength={120}
          />
        </FieldShell>
      )}

      <FieldShell label="Do health or medical problems run in your family?">
        <YesNoToggle
          value={responses.family_history_present}
          onChange={(v) => setField('family_history_present', v)}
        />
      </FieldShell>

      {responses.family_history_present === true && (
        <FieldShell
          label="Family medical history details"
          htmlFor="family_history"
          help="Example: Father had heart disease, mother had diabetes."
        >
          <BigTextArea
            id="family_history"
            value={responses.family_history}
            onChange={(v) => setField('family_history', v)}
          />
        </FieldShell>
      )}
    </div>
  );
};

export default LifestyleSection;
